export default (target: any): target is HTMLElement => target && ('closest' in target)
